import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./definition-list.css?inline";
import "./definition-list-item";
import "./definition-list-term";
import "./definition-list-description";

@customElement("eko-definition-list")
class DefinitionList extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ type: Number, reflect: true }) columns?: number;
  @property({ reflect: true }) flow?: "column" | "row"; // Default is "column"
  @property({ reflect: true }) layout?: "horizontal" | "vertical"; // Default is "horizontal"

  render() {
    return html`
      <dl
        part="root"
        class="eko-definition-list"
        style=${this.columns && Number.isInteger(this.columns) && this.columns >= 1
          ? `--_eko-definition-list-columns: ${this.columns}`
          : nothing}>
        <slot></slot>
      </dl>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-definition-list": DefinitionList;
  }
}

export default DefinitionList;
